var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgTransparent = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    "data-name": "Layer 1",
    viewBox: "0 0 52 52",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m48.5 5.6-2.1-2.1a1.67 1.67 0 0 0-2.4.3L32.59 15.21c-.77-1.3-1.51-2.61-2.21-4a36.5 36.5 0 0 1-3.15-8.36c-.13-.53-.39-.91-1-.89s-.86.4-1 .93c-.06.26-.11.51-.17.76A48.3 48.3 0 0 1 21 13.7 97.5 97.5 0 0 1 14.13 25a16 16 0 0 0-3 11.12c0 .14 0 .29.06.43L3.8 44a1.87 1.87 0 0 0-.3 2.4l2.1 2.1a1.67 1.67 0 0 0 2.4-.3L48.2 8a1.67 1.67 0 0 0 .3-2.4M38.42 23.79l-22 22.31a14.47 14.47 0 0 0 9.8 3.9 15.5 15.5 0 0 0 7-1.44c4.94-2.51 8.11-6.4 8.94-12A15.22 15.22 0 0 0 39 24.66c-.13-.22-.42-.66-.58-.87"
  })));
};
export default SvgTransparent;